import React, { lazy, Suspense } from 'react'

const AdProvider = lazy(() =>
  import('../../Context').then((module) => ({ default: module.AdProvider }))
)

const SeasonProvider = lazy(() =>
  import('../../Context').then((module) => ({ default: module.SeasonProvider }))
)

const VideoProvider = lazy(() =>
  import('../../Context').then((module) => ({ default: module.VideoProvider }))
)

const SlideupProvider = lazy(() =>
  import('../../Context/SlideupContext').then((module) => ({
    default: module.SlideupProvider,
  }))
)

const BrazeProvider = lazy(() =>
  import('../../Context').then((module) => ({
    default: module.BrazeProvider,
  }))
)

type FeatureProvidersProps = {
  children: React.ReactNode
}

const FeatureProviders: React.FC<FeatureProvidersProps> = ({ children }) => {
  return (
    <Suspense fallback={<></>}>
      <AdProvider>
        <SlideupProvider>
          <BrazeProvider>
            <SeasonProvider>
              <VideoProvider>{children}</VideoProvider>
            </SeasonProvider>
          </BrazeProvider>
        </SlideupProvider>
      </AdProvider>
    </Suspense>
  )
}

export default FeatureProviders
